import { useTranslation } from 'react-i18next';

import { Button, CircleCheckmarkIcon, Modal, Paragraph, Popover } from '@treams/treams-ui';

// Confirms submitting the grid for a cycle moment and explains what that does.
export default function SubmitTalentReviewModal(props: {
	/** Title of the cycle moment the review is submitted for. */
	title: string;
	loading?: boolean;
	onClose: () => void;
	onConfirm: () => void;
}) {
	const { t } = useTranslation();

	return (
		<Popover visible center onDismiss={props.onClose}>
			<Modal>
				<Modal.Header title={t('talentReviews.v2.cycle.submit')} onClose={props.onClose} />
				<Modal.Contents>
					<Paragraph>{t('talentReviews.v2.cycle.submitConfirm', { title: props.title })}</Paragraph>
				</Modal.Contents>
				<Modal.Footer>
					<Button
						type="secondary"
						title={t('talentReviews.v2.cancel')}
						disabled={props.loading}
						onClick={props.onClose}
					/>
					<Button
						ml={2}
						type="primary"
						icon={<CircleCheckmarkIcon />}
						title={t('talentReviews.v2.cycle.submit')}
						loading={props.loading}
						onClick={props.onConfirm}
					/>
				</Modal.Footer>
			</Modal>
		</Popover>
	);
}
